import Swiper from 'tiny-swiper/lib/index.full';
import SwiperPluginNavigation from 'tiny-swiper/lib/modules/navigation' ;

// const swiperContainer = document.querySelector('.swiper-container');
// console.log(swiperContainer)
Swiper.use([SwiperPluginNavigation]);

// Load slider if available.
let sliderHome = document.querySelector('.swiper-container');

if(null != sliderHome) {
  const swiper = new Swiper('.swiper-container', {
    loop: true,
    mousewheel: {
      invert: false,
      interval: 400
    },
    navigation: {
      prevEl: ".swiper-plugin-navigation-prevEl",
      nextEl: ".swiper-plugin-navigation-nextEl"
    },
    
    plugins: [SwiperPluginNavigation]
  });
}